import { render } from "./AposTiptapLink.vue?vue&type=template&id=7642c782&scoped=true"
import script from "./AposTiptapLink.vue?vue&type=script&lang=js"
export * from "./AposTiptapLink.vue?vue&type=script&lang=js"

import "./AposTiptapLink.vue?vue&type=style&index=0&id=7642c782&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7642c782"],['__file',"rich-text-widget/ui/apos/components/AposTiptapLink.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7642c782"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7642c782', __exports__)) {
    api.reload('7642c782', __exports__)
  }
  
  module.hot.accept("./AposTiptapLink.vue?vue&type=template&id=7642c782&scoped=true", () => {
    api.rerender('7642c782', render)
  })

}


export default __exports__